module.exports = __webpack_public_path__ + "img/bus.007117af.svg";